<template>
    <div class="d-flex">
        <div class="col-md-3 card-totalDespesas">
            <paneldetails :totalFuncionarioDespesas="totalFuncionarioDespesas" :dataDetails="dataDetails" v-if="!flagDetailsDespesa" @onLoadFuncionario="onLoadFuncionario"></paneldetails>
            <paneldetailsdespesas @modalEnviaCoordenadorUnicaDespesa="modalEnviaCoordenadorUnicaDespesa" :StatusNotEdit="StatusNotEdit" @aprovar="Modalaprovar(datadespesa)" @reprovar="modalDevolucaoUnicaDespesa(datadespesa)" @preaprovar="PreApprovedDespesaByid(datadespesa)" :datadespesa="datadespesa" :usuarioGrupoDV="usuarioGrupoDV" v-else></paneldetailsdespesas>
        </div>
        <div class="col-md-9">
            <div v-if="!flagDetailsDespesa">
                <div class="details-body">
                    <HeadDetailsGama :titleHead="'Lista de Despesa'" :buttontemplate="true">
                        <template #button-edit>
                            <div class="d-flex">
                                <button v-if="(hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL)) && allInDirectoryStatus" class="btn-revisar mr-2" @click="openReviewModal"><i class="fas fa-undo-alt mr-1" ></i>REVISAR</button>
                                <button v-if="!allInDirectoryStatus" class="btn-reprovar" @click="modalEscolhaReprova"><i class="fas fa-thumbs-down mr-1" ></i>REPROVAR</button>
                                <button v-if="!allInDirectoryStatus && !hasRole(roles.ACC_FIN_MISCELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL)" @click="ToApproveContraladoria" class="btn-aprovar ml-2"><i class="fas fa-thumbs-up mr-1"></i>APROVAR</button>
                                <button v-if="!allInDirectoryStatus && hasRole(roles.ACC_FIN_MISCELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL)" @click="ModalEnviarCoordenador" class="btn-aprovar ml-2"><i class="fas fa-thumbs-up mr-1"></i>APROVAR</button>
                            </div>
                        </template>
                    </HeadDetailsGama>
                    <b-modal ref="modal-review-confirm-diversos"
                        size="md"
                        centered
                        title="Confirmar Revisão"
                        :hide-footer="true"
                        :no-close-on-backdrop="true"
                        :no-close-on-esc="true">
                        <div class="review-modal-icon">
                            <i class="fas fa-undo-alt"></i>
                        </div>
                        <div class="review-modal-label">
                            Confirma o retorno das despesas selecionadas para Controladoria?
                        </div>
                        <div v-if="hasRole(roles.RW_REAL_ESTA_ADMIN)" class="review-modal-warning">
                            Atenção: como perfil Administrativo, despesas que já estiverem vinculadas a um lote serão removidas do lote.
                        </div>
                        <div class="review-modal-actions">
                            <button @click="closeReviewModal" class="review-btn-cancel">CANCELAR</button>
                            <button @click="confirmReview" class="review-btn-confirm">CONFIRMAR</button>
                        </div>
                    </b-modal>
                    <!-- ZC-44: Log tambem AQUI, antes de entrar na despesa. As abas ficam DEPOIS do
                         HeadDetailsGama para os botoes REVISAR/REPROVAR/APROVAR valerem nas duas, e
                         o `tableoccourenciadetails` NAO pode ser desmontado (o pai usa o ref dele),
                         por isso b-tabs sem v-if e sem lazy. -->
                    <b-tabs class="mt-2">
                    <b-tab :title="'Lista de Despesa'">
                        <template slot="title">
                            <i class="fas fa-list-ul text-third"></i><span class="d-md-down-none pl-1 text-third"> Lista de Despesa</span>
                        </template>
                        <tableoccourenciadetails  ref="tableoccourenciadetails" :filtroEmpresa="filtroEmpresa" :despesasid="despesasid" @detailsDespesa="detailsDespesa" @eventcheck="eventcheck" @despesasLoaded="onDespesasLoaded"/>
                    </b-tab>
                    <b-tab :title="'Log'">
                        <template slot="title">
                            <i class="fas fa-tasks text-third"></i><span class="d-md-down-none pl-1 text-third"> Log</span>
                        </template>
                        <div class="p-3">
                            <div class="sub-title mb-3">Log de Status das despesas listadas</div>
                            <!-- os ids vem da GRID (`onDespesasLoaded`), nao de funcionario+empresa:
                                 o endpoint da grid filtra por perfil e pagina, entao so assim o log
                                 mostra exatamente as despesas que estao na tela -->
                            <LogDespesa :despesa-ids="idsDasDespesasNaGrid" />
                        </div>
                    </b-tab>
                    </b-tabs>
                </div>
            </div>
            <div v-else class="bg-white p-3">
                <div  class="details-body ">
                <HeadDetailsGama :btnCanceSave="StatusNotEditButon" buttonbackCustom="N" @back="backAllDespesas" @save="UpdateDespesasDiversos" :titleHead="'Detalhe do Reembolso'" :iconCancel="'fas fa-times-circle'" :iconSave="'fas fa-check-circle'"></HeadDetailsGama>
                <!-- ZC-44: o detalhe da despesa virou 2 abas para caber o Log, do mesmo jeito que o
                     Reembolso de Viagem (FormDetailsAdvance.vue). O HeadDetailsGama fica FORA das
                     abas de proposito: os botoes Voltar/Salvar valem nas duas. -->
                <b-tabs class="mt-2">
                <b-tab :title="'Detalhe'">
                    <template slot="title">
                        <i class="fas fa-file-invoice-dollar text-third"></i><span class="d-md-down-none pl-1 text-third"> Detalhe do Reembolso</span>
                    </template>
                <div class="p-3">
                    <div class="d-flex mt-2">
                        <div class="col-md-12">
                            <div class="sub-title">Dados da Despesa</div>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-md-2">
                            <label class="label-details-despesas">Quantidade</label>
                            <input disabled="true" class="form-control text-left" type="number"  v-model="funcionarioVinculados.length">
                        </div>
                        <div class="col-md-2">
                            <label class="label-details-despesas">Valor</label>
                            <money class="form-control form-control-10 text-left"
                                v-bind="formatMoneyHtml()"
                                :disabled=" datadespesaEdit.statusDespesa === 3 || datadespesaEdit.primeiroAdiantamento === true || datadespesaEdit.saldo === true ? true : StatusNotEdit "
                                :placeholder="formatMoneyHtml().prefix"
                                :prefix="formatMoneyHtml().prefix"
                                v-model="datadespesaEdit.valor"/>
                        </div>
                        <div class="col-md-3">
                            <label class="label-details-despesas" >Categoria</label>
                            <select :disabled="StatusNotEdit"  class="form-control" v-model="datadespesaEdit.subCategoria" v-if="datadespesaEdit.subCategoria !== null">
                                <option v-for="data in dataAllSubCategoria" :key="data.value" :value="data.value">{{data.text}}</option>
                            </select>
                            <select disabled  class="form-control" v-model="datadespesaEdit.subCategoriaDescricao" v-else>
                                <option :key="datadespesaEdit.subCategoriaDescricao" :value="datadespesaEdit.subCategoriaDescricao">{{datadespesaEdit.subCategoriaDescricao}}</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label class="label-details-despesas">Data</label>
                            <datepicker
                            :format="'dd/MM/yyyy'"
                            :disabled="StatusNotEdit"
                            v-model="datadespesa.dataRegistroDespesa"
                            :language="ptBR"
                            :placeholder="$lang.Common.DatePlaceholder"
                            :calendar-button="true"
                            :calendar-button-icon="'fa fa-calendar'"
                            :bootstrap-styling="true"
                            :full-month-name="true"
                            :use-utc="true"
                            />
                        </div>
                        <div class="col-md-2">
                            <label class="label-details-despesas" >Status</label>
                            <div class="status-despesas-diversos statusDespesa" :style="{'background-color': datadespesaEdit.statusDespesa === 3 ? '#0056b3' : datadespesaEdit.statusDespesa === 9 ? '#e65c17' : datadespesaEdit.colorStatusDespesa}" v-b-tooltip.hover :title="datadespesaEdit.statusDespesaDescricao">
                                <div v-if="datadespesaEdit.statusDespesa === 2">
                                    AG. CONTROLADORIA
                                </div>
                                <div v-else-if="datadespesaEdit.statusDespesa === 3">
                                    AG. DIRETORIA
                                </div>
                                <div v-else-if="datadespesaEdit.statusDespesa === 1">
                                    AG. COORDENADOR
                                </div>
                                <div v-else-if="datadespesaEdit.statusDespesa === 9">
                                    AG. TÉCNICO
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex mt-3">
                    </div>
                    <div class="d-flex mt-3">
                        <div class="col-md-12">
                            <label class="label-details-despesas">Observação</label>
                            <textarea :disabled="StatusNotEdit"  class="form-control" v-model="datadespesaEdit.observacao" ></textarea>
                        </div>
                    </div>

                    <div class="d-flex mt-5">
                        <div class="col-md-4">
                            <div class="d-flex gap">
                                <div class="sub-title">Funcionários Vinculados</div>
                                <div v-if="!
                                StatusNotEdit" class="add-funcionario" @click="AddEmployer"> <i class="fas fa-plus-circle icone-Adicionar mr-1"></i> </div>
                            </div>
                            <div class="mb-3">
                            <p class="label-funcionario-codigo mb-2">Código do funcionário 1</p>
                            <div class="d-flex gap-input-funcionario">
                                <input disabled class="form-control w-25" :id="'form-funcionario-code-'" v-model="dataDetails.codigo">
                                <input disabled class="form-control w-75" :id="'form-funcionario-text-'" v-model="dataDetails.nomeColaborador">
                            </div>
                            </div>
                            <div v-for="(data, index) in funcionarioVinculados" class="mb-3" :key="index">
                                <!-- <label class="label-details-despesas" v-if="index >= 1">Código do Funcionário - {{index + 1}}</label> -->
                                <p class="label-funcionario-codigo mb-2" v-if="index >= 1">Código do funcionário {{index + 1}}</p>

                                <div class="gap-input-funcionario" v-if="index >= 1" >
                                <div class="remove-more-people" v-if="!
                                StatusNotEdit" @click="removerfuncionario(index)"><i class="fas fa-minus-circle"></i></div>
                                    <input :disabled="StatusNotEdit" class="form-control w-25" :id="'form-funcionario-code-' + index"  @change="changeFuncionarioByCodigo($event, index)" v-model="data.funcionario.codigo">
                                    <input :disabled="StatusNotEdit" class="form-control w-75" :id="'form-funcionario-text-' + index" v-model="data.funcionario.nome">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="sub-title">Comprovante</div>
                            <div class="comprovante-file">
                                <i class="fas fa-file-pdf icone-comprovante" @click="openDetailsimg" v-if="datadespesaEdit.midia.name.includes('.pdf')"></i>
                                <i class="far fa-file-excel icone-comprovante" v-if="datadespesaEdit.midia.name.includes('.xlsx')"></i>
                                <img class="image-comprovante" @click="openDetailsimg" v-else-if="!datadespesaEdit.midia.name.includes('.pdf') && !datadespesaEdit.midia.name.includes('.xlsx')" :src="'data:image/png;base64,' + stringFile" />
                            <div class="comprovante-footer">{{datadespesaEdit.midia.name == null ? 'N/D' : datadespesaEdit.midia.name }}</div>
                                <div class="download-comprovante" @click="downloadComprovante" ><i class="fas fa-download"></i></div>
                            </div>
                        </div>
                        <div class="ml-2 col-md-4" v-if="datadespesaEdit.motivoRecusa != null">
                            <p class="sub-title">Motivo Devolução</p>
                            <div class="caxa-texto">
                                <textarea class="Ajuste-Devolucao form-control mt-3" rows="8" cols="100" disabled="true" v-model="datadespesaEdit.motivoRecusa"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                </b-tab>
                <b-tab :title="'Log'">
                    <template slot="title">
                        <i class="fas fa-tasks text-third"></i><span class="d-md-down-none pl-1 text-third"> Log</span>
                    </template>
                    <div class="p-3">
                        <div class="sub-title mb-3">Log de Status</div>
                        <LogDespesa :despesa-id="despesaid" />
                    </div>
                </b-tab>
                </b-tabs>
            </div>
            </div>
        </div>
        <b-modal ref="modal-apr" hide-footer hide-header centered>
            <div class="d-flex justify-content-center">
                <i class="fas fa-clipboard-check icone-modal" ></i>
            </div>
            <div class="d-flex justify-content-center mt-3">
                <div class="info-poups">Tem certeza que deseja aprovar essa despesa?</div>
            </div>
            <div class="d-flex justify-content-between mt-4">
                <button class="button-modal-rep" @click="closemodalAprovar">NÃO</button>
                <button class="button-modal-apr" :tableGrids='tableGrids' @click="NextStatus">SIM</button>
            </div>
        </b-modal>

       <b-modal ref="Detailsimg"    hide-footer
            centered title="COMPROVANTE">
            <div v-if="datadespesaEdit.midia != null">
                <img class="img-details-modal" v-if="!datadespesaEdit.midia.name.includes('.pdf')" :src="'data:image/png;base64,' + stringFile" />
             <iframe
                    style="overflow: hidden"
                    id="pdfViewer"
                    v-else
                    scrolling="no"
                    class="mb-2 img-details-modal"
                    :src="'data:application/pdf;base64,'+ stringFile + '#toolbar=0&navpanes=0&scrollbar=0'" frameborder="0">
                  </iframe>
            </div>
        </b-modal>

        <b-modal ref="modal-EscolhaReprova"
            size="md"
            centered
            id="add-brower-modal"
            title="Reprovação"
            :hide-footer="true"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
        >
            <div class="icone-reprova">
                <i class="fas fa-thumbs-down"></i>
            </div>
            <div>
                <div class="labelmodal conteiner">Escolha o tipo de reprovação!</div>
            </div>
            <div v-if="impedeDevolucao">
                <div class="label-atencao warning-devolucao">
                  <div class="mb-2 labelmodal"><i class="mr-2 fa fa-exclamation-triangle text-warning"></i>Atenção!</div>
                  <div class="p-2">A despesa selecionada não pode ser devolvida pois pertence ao tipo de <b>{{motivoBloqueio}}</b></div>
                </div>
            </div>
            <div class="conteiner pt-3">
                <!-- <button @click="voltarEscolhaReprova" class="button-cancel">VOLTAR</button> -->
                <button v-if="UnicaDespesa == false" @click="modal" :disabled='impedeDevolucao' :class='alertsStyle()'>DEVOLUÇÃO</button>
                <button v-if="UnicaDespesa == true" @click="modalDevolucaoUnicaDespesaDevolver" :disabled='impedeDevolucao' :class='alertsStyle()'>DEVOLUÇÃO</button>
                <button v-if="UnicaDespesa == false" @click="modalDefinitivo" class="button-reprova">DEFINITIVA</button>
                <button v-if="UnicaDespesa == true" @click="modalDevolucaoUnicaDespesaDefinitivo" class="button-reprova">DEFINITIVA</button>
            </div>
        </b-modal>

        <b-modal ref="modal-EscolhaReprovaUnica"
            size="md"
            centered
            id="add-brower-modal"
            title="Reprovação"
            :hide-footer="true"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
        >
            <div class="icone-reprova">
                <i class="fas fa-thumbs-down"></i>
            </div>
            <div>
                <div class="labelmodal conteiner">Escolha o tipo de reprovação!</div>
            </div>
            <div v-if="impedeDevolucao">
                <div class="label-atencao warning-devolucao">
                  <div class="mb-2 labelmodal"><i class="mr-2 fa fa-exclamation-triangle text-warning"></i>Atenção!</div>
                  <div class="p-2">A despesa selecionada não pode ser devolvida pois pertence ao tipo de <b>{{despesaDetails.subCategoriaDescricao}}</b></div>
                </div>
            </div>
            <div class="conteiner pt-3">
                <!-- <button @click="voltarEscolhaReprova" class="button-cancel">VOLTAR</button> -->
                <button v-if="UnicaDespesa == false" @click="modal" :disabled='impedeDevolucao' :class='alertsStyle()'>DEVOLUÇÃO</button>
                <button v-if="UnicaDespesa == true" @click="modalDevolucaoUnicaDespesaDevolver" :disabled='impedeDevolucao' :class='alertsStyle()'>DEVOLUÇÃO</button>
                <button v-if="UnicaDespesa == false" @click="modalDefinitivo" class="button-reprova">DEFINITIVA</button>
                <button v-if="UnicaDespesa == true" @click="modalDevolucaoUnicaDespesaDefinitivo" class="button-reprova">DEFINITIVA</button>
            </div>
        </b-modal>

        <b-modal ref="devolver-despesa"
            size="md"
            centered
            id="add-brower-modal"
            :title= "definitivo == true ? 'Reprovação Definitiva da Despesa' : 'Devolução da Despesa'"
            :hide-footer="true"
            :clickToClose="true"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            :hide-header-close="true"
        >
            <div>
                <div v-if="definitivo == false" class="label conteiner">Informe o motivo da devolução!</div>
                <div v-else class="label conteiner">Informe o motivo da reprovação!</div>
                <div class="caxa-texto conteiner">
                    <textarea class="form-control mt-3" rows="10" cols="175" v-model="motivo"></textarea>
                </div>
            </div>
            <div class="conteiner pt-3">
                <button @click="voltar" class="button-cancel">VOLTAR</button>
                <button v-if="UnicaDespesa == false" @click="ReproachContraladoria(definitivo == true ? true : false)" class="button-save">SALVAR</button>
                <button v-if="UnicaDespesa == true" @click="Reprove(definitivo == true ? true : false)" class="button-save">SALVAR</button>
            </div>
        </b-modal>

        <b-modal ref="modal-envio-coordenador"
            size="md"
            centered
            id="add-brower-modal"
            title= "Enviar para o Coordenador"
            :hide-footer="true"
            :clickToClose="true"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            :hide-header-close="true"
        >
        <addCoordinator @fechaModalAprovacaoEnvioCoordenador="fechaModalAprovacaoEnvioCoordenador" @onloadReacarregar="onloadReacarregar" :UnicaDespesa="UnicaDespesa"  @fecharEnviarCoordenador="fecharEnviarCoordenador" :despesasidEnviarCoordenador="despesasidEnviarCoordenador"></addCoordinator>
        </b-modal>
    </div>
</template>

<script>
import detailsmiscellaneousreimbursement from './detailsmiscellaneousreimbursement'
export default detailsmiscellaneousreimbursement

</script>

<style scoped>
.labelmodal{
    padding: 1rem;
    font: normal normal 600 15px/20px Segoe UI;
    font-size: 20px;
    font-weight: bold;
}
.label-atencao{
    padding: 1rem;
    font: normal normal 600 15px/20px Segoe UI;
    font-size: 14px;
    font-weight: bold;
}
.icone-reprova{
    display: flex;
    font-size: 44px;
    padding: 10px;
    justify-content: center;
}
.Ajuste-Devolucao{
  border-radius: 13px;
}
.conteiner{
    display: flex;
    gap: 4rem;
    justify-content: center;
}
.icone{
    font-size: 50px;
    color: rgb(167, 30, 30);
}
.label{
    padding-top: 0.5rem;
    font: normal normal 600 15px/20px Segoe UI;
    font-size: 20px;
    font-weight: bold;
}

.label-funcionario-codigo{
    padding-top: 0.5rem;
    font: normal normal 600 13px/20px Segoe UI;
    font-weight: bold;
}
.button-cancel{
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(167, 30, 30);
}
.button-info{
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(208 195 43);
}
.button-reprova{
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(168 28 6);
}
.button-save {
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(4, 90, 30);
}
.button-disabled {
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    background-color: #dedede;
    color: #747474;
}
.gap{
    gap: 0.5rem;
}
.card-totalDespesas{
    padding-right: 0;
    padding-left: 0
}

.flex{
    display: flex;
    justify-content: center;
}
.button-cancel,
.button-save{
   outline: transparent;
   border: transparent;
   border-radius: 4px;
   text-transform: uppercase;
   width: 190px;
   height: 40px;
}
.button-cancel{
   background-color: #dedede;
   color: #747474;
}
.button-save{
   background-color: #008148;
   color: white;
}
.icon-atualiza-credito{
    color: #008148;
    font-size: 5rem;
}
.icone-pdf{
    color: #008144;
}
.details-body{
    height: fit-content;
    overflow: auto;
    background: white;
    border: 1px solid rgb(211, 210, 210);
    border-radius: 6px
}
.gap-input-funcionario{
    display: flex;
    gap: 5px;
}
.label-details-despesas{
    font-size: 14px;
    font-weight: bold;
    line-height: 2px;
}
.img-details-modal{
    width: 100%;
    object-fit: contain;
}
.status-despesas-diversos{
    padding-top: 5px;
    padding-bottom: 5px;
    display: flex;
    width: 100%;
    font-weight: bold;
    align-items: center;
    justify-content: center;
    border-radius: 25px;
    background: #008144;
    color: white;
    text-align: center;
}
@media (max-width: 1280px) {
  .statusDespesa {
    font-size: 7px;
  }
}
@media (min-width: 1281px) {
  .statusDespesa {
    font-size: 10px;
  }
}
.button-modal-rep{
    width: 45%;
    height: 40px;
    background: gray;
    border: none;
    font-size: 18px;
     border-radius: 10px;
    color: white;
    font-weight: bold;
}
.button-modal-apr{
    width: 45%;
    height: 40px;
    background: #008144;
    font-size: 18px;
    border: none;
    border-radius: 10px;
    color: white;
    font-weight: bold;
}
.icone-comprovante{
    font-size: 60px;
    color: rgb(189, 189, 189);
}
.info-poups{
    font-size: 18px;
    text-align: center;
    margin: 4rem 0 2rem 0;
    font-weight: bold;
}
.icone-modal{
    font-size: 70px;
    color: #008144;
}
.image-comprovante{
    height: 100%;
    border-radius: 10px;
    width: 100%;
    object-fit: contain;
}
.button-apr{
    height: 45px;
    width: 200px;
    background: #008144;
    color: white;
    font-weight: bold;
    border: none;
    border-radius: 4px;
}
.button-rep{
     height: 45px;
    width: 200px;
    background: red;
    color: white;
    font-weight: bold;
    border: none;
    border-radius: 4px;
}
.download-comprovante{
    height: 30px;
    position: absolute;
    top: 0px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    right: 0px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    color: white;
    cursor: pointer;
    width: 40px;
    background: #008144;
    border-radius: 0px 8px 0px 8px;
}
.add-funcionario{
    color: #008144;
    font-size: 17px;
    cursor: pointer;
}

.remove-more-people{
    color: red;
    font-size:  17px;
    cursor: pointer;
    display: flex;
    align-items: center;
}

.comprovante-footer{
    width: 100%;
    white-space: pre-wrap;
    word-break: break-all;
    height: fit-content;
    padding: 5px;
    position: absolute;
    font-weight: bold;
    background: rgb(216, 216, 216);
    bottom: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: gray;
    border-radius: 0px 0px 10px 10px;
}
.comprovante-file{
    height: 175px;
    display: flex;
    position: relative;
    justify-content: center;
    cursor: pointer;
    align-items: center;
    border: 1px solid rgb(224, 224, 224);
    border-radius: 10px;
}
.sub-title{
    font-size: 16px;
    font-weight: bold;
    color: #008144;
    margin-bottom: 20px;
}
.warning-devolucao{
    display: flex;
    gap: 1rem;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.button-revise{
    height: 2.5rem;
    padding: 0 1rem;
    background: #ffa726;
    color: white;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    display: flex;
    align-items: center;
}
.button-revise:hover{
    background: #fb8c00;
}
.review-modal-icon{
    display: flex;
    font-size: 44px;
    padding: 10px;
    justify-content: center;
    color: #ffa726;
}
.review-modal-label{
    padding: 0.5rem 1rem;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
}
.review-modal-warning{
    padding: 0.5rem 1rem;
    margin-top: 0.5rem;
    font-size: 13px;
    color: #b25500;
    background-color: #fff3e0;
    border-left: 4px solid #ffa726;
    border-radius: 4px;
}
.review-modal-actions{
    display: flex;
    gap: 1rem;
    justify-content: center;
    padding-top: 1.5rem;
}
.review-btn-cancel{
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(167, 30, 30);
}
.review-btn-confirm{
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: #008144;
}
.review-btn-confirm:hover{
    background-color: #024d2a;
}
</style>



// WEBPACK FOOTER //
// src/views/private/miscellaneousreimbursement/components/detailsmiscellaneousreimbursement/detailsmiscellaneousreimbursement.vue